(() => {
  const selector = '[data-ks-cart-minimum]';
  const buttonSelector = '[data-ks-minimum-checkout]';
  const displayDuration = 4200;
  const timers = new WeakMap();

  function cents(value) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? Math.max(0, Math.round(parsed)) : 0;
  }

  function amount(value) {
    return new Intl.NumberFormat('en-CA', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(cents(value) / 100);
  }

  function update(wrapper, subtotal) {
    if (!(wrapper instanceof HTMLElement)) return;
    const minimum = cents(wrapper.dataset.minimumSubtotal || 35000);
    const current = cents(subtotal ?? wrapper.dataset.cartSubtotal);
    const remaining = Math.max(0, minimum - current);
    const belowMinimum = remaining > 0;
    const button = wrapper.querySelector(buttonSelector);
    const tooltip = wrapper.querySelector('.ks-cart-minimum-tooltip');

    wrapper.dataset.cartSubtotal = String(current);
    if (belowMinimum) wrapper.dataset.belowMinimum = 'true';
    else delete wrapper.dataset.belowMinimum;

    if (tooltip) {
      const message = `Minimum order: $350 CAD. Add $${amount(remaining)} more to checkout.`;
      if (tooltip.textContent.trim() !== message) tooltip.textContent = message;
    }
    if (button && tooltip) {
      if (belowMinimum) button.setAttribute('aria-describedby', tooltip.id);
      else button.removeAttribute('aria-describedby');
    }
    if (!belowMinimum) hide(wrapper);
  }

  function updateAll(subtotal) {
    document.querySelectorAll(selector).forEach((wrapper) => update(wrapper, subtotal));
  }

  function hide(wrapper) {
    const timer = timers.get(wrapper);
    if (timer) window.clearTimeout(timer);
    timers.delete(wrapper);
    wrapper.classList.remove('is-tooltip-visible');
  }

  function show(wrapper) {
    hide(wrapper);
    wrapper.classList.add('is-tooltip-visible');
    timers.set(wrapper, window.setTimeout(() => hide(wrapper), displayDuration));
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest(buttonSelector);
    const wrapper = button?.closest(selector);
    if (!button || !wrapper || wrapper.dataset.belowMinimum !== 'true') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    show(wrapper);
  }, true);

  document.addEventListener('submit', (event) => {
    const button = event.submitter?.matches(buttonSelector) ? event.submitter : null;
    const wrapper = button?.closest(selector);
    if (!button || !wrapper || wrapper.dataset.belowMinimum !== 'true') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    show(wrapper);
  }, true);

  document.addEventListener('pointerout', (event) => {
    const wrapper = event.target.closest?.(selector);
    if (wrapper && !wrapper.contains(event.relatedTarget)) hide(wrapper);
  });

  document.addEventListener('click', (event) => {
    document.querySelectorAll(`${selector}.is-tooltip-visible`).forEach((wrapper) => {
      if (!wrapper.contains(event.target)) hide(wrapper);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll(`${selector}.is-tooltip-visible`).forEach(hide);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event?.cartData && Number.isFinite(Number(event.cartData.total_price))) {
        updateAll(event.cartData.total_price);
      } else {
        updateAll();
      }
    });
  }

  let drawerObserver;
  let drawerOpenObserver;

  function stopDrawerObserver() {
    drawerObserver?.disconnect();
    drawerObserver = null;
  }

  function observeOpenDrawer() {
    const drawer = document.querySelector('cart-drawer.active');
    if (!drawer || drawerObserver) return;
    drawerObserver = new MutationObserver(() => updateAll());
    drawerObserver.observe(drawer, { childList: true, subtree: true });
  }

  function start() {
    updateAll();
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    drawerOpenObserver = new MutationObserver(() => {
      if (drawer.classList.contains('active')) observeOpenDrawer();
      else stopDrawerObserver();
    });
    drawerOpenObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    if (drawer.classList.contains('active')) observeOpenDrawer();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
